import styled from 'styled-components';

const InviteFinish = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const InviteFinishHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const InviteFinishCard = styled.div`
  align-items: center;
  background-color: var(--color-bg-default);
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 40px;
`;

const InviteFinishCardSuccess = styled.div`
  align-items: center;
  border: 1px solid var(--color-success-default);
  border-radius: 50%;
  display: flex;
  height: 96px;
  justify-content: center;
  width: 96px;
`;

export { InviteFinish, InviteFinishCard, InviteFinishCardSuccess, InviteFinishHeader };
